import React, { Fragment } from 'react';
import { CheckIcon } from 'lucide-react';
interface StepperProps {
  steps: {
    id: number;
    title: string;
  }[];
  activeStep: number;
  onStepClick: (step: number) => void;
}
export const Stepper: React.FC<StepperProps> = ({
  steps,
  activeStep,
  onStepClick
}) => {
  return <div className="w-full" data-id="element-401">
      <div className="flex items-center justify-between" data-id="element-402">
        {steps.map((step, index) => <Fragment key={step.id} data-id="element-403">
            <div className="flex flex-col items-center" data-id="element-404">
              <button onClick={() => index <= activeStep && onStepClick(step.id)} disabled={index > activeStep} className={`
                  flex items-center justify-center w-10 h-10 rounded-full 
                  ${index < activeStep ? 'bg-[#E3000F] text-white' : index === activeStep ? 'bg-[#E3000F] text-white' : 'bg-gray-200 text-gray-500'}
                  ${index <= activeStep ? 'cursor-pointer' : 'cursor-not-allowed'}
                  transition-all duration-200
                `} data-id="element-405">
                {index < activeStep ? <CheckIcon className="w-5 h-5" data-id="element-406" /> : <span data-id="element-407">{index + 1}</span>}
              </button>
              <span className={`
                  mt-2 text-sm font-medium
                  ${index <= activeStep ? 'text-gray-800' : 'text-gray-500'}
                `} data-id="element-408">
                {step.title}
              </span>
            </div>
            {index < steps.length - 1 && <div className={`
                  flex-1 h-1 mx-2
                  ${index < activeStep ? 'bg-[#E3000F]' : 'bg-gray-200'}
                `} data-id="element-409" />}
          </Fragment>)}
      </div>
    </div>;
};